const toggleTab = (header) => {
	const tab = header.closest('.collapsible-tab');
	const content = document.getElementById(header.getAttribute('aria-controls'));
	const isOpen = tab.classList.toggle('is-open');

	header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

	if (!content) return;

	if (isOpen) {
		content.removeAttribute('aria-hidden');
		content.removeAttribute('inert');
	} else {
		content.setAttribute('aria-hidden', 'true');
		content.setAttribute('inert', '');
	}
};

// Delegated on document (not bound per-header) so tabs rendered later —
// e.g. Sprig swapping in filtered FAQ search results — still toggle
// without needing a re-init hook.
document.addEventListener('click', (event) => {
	const header = event.target.closest('.collapsible-tab--header');
	if (!header) return;
	toggleTab(header);
});
